import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = {
  key: 0,
  class: "container is-tp-container"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "title is-2" }, "Stats", -1)
const _hoisted_4 = { class: "columns mt-6" }
const _hoisted_5 = { class: "column is-6" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "From", -1)
const _hoisted_8 = { class: "control" }
const _hoisted_9 = { class: "column is-6" }
const _hoisted_10 = { class: "field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "To", -1)
const _hoisted_12 = { class: "control" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "column is-12" }, null, -1)
const _hoisted_14 = { class: "columns form-group is-mobile mt-2 is-aligned-flex-end" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "column" }, null, -1)
const _hoisted_16 = { class: "column is-narrow is-pulled-right" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "search", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  class: "columns is-multiline mt-3 is-centered",
  "data-test": "stats-chart"
}
const _hoisted_20 = { class: "column is-5" }
const _hoisted_21 = {
  key: 0,
  class: "column is-5"
}
const _hoisted_22 = {
  key: 1,
  class: "notification mt-3 title is-5",
  "data-text": "error-no-records"
}
const _hoisted_23 = {
  key: 1,
  class: "container is-tp-container",
  "data-text": "error-permissions"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "title is-2" }, "You don't have the required permissions to read Logs", -1)
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_TPChart = _resolveComponent("TPChart")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.allowed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_Form, {
            id: "LogsForm",
            name: "LogsForm",
            onSubmit: _ctx.getStats,
            "data-test": "filter-form"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_Field, {
                        modelValue: _ctx.createdAt.gte,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.createdAt.gte) = $event)),
                        name: "From",
                        id: "From",
                        class: "input",
                        type: "date",
                        placeholder: "From",
                        ref: "From",
                        "data-test": "from-date"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "From",
                        class: "has-text-danger is-tp-input-error"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_Field, {
                        modelValue: _ctx.createdAt.lte,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.createdAt.lte) = $event)),
                        name: "To",
                        id: "To",
                        class: "input",
                        type: "date",
                        placeholder: "From",
                        ref: "To",
                        rules: _ctx.maxDate,
                        "data-test": "to-date"
                      }, null, 8, ["modelValue", "rules"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "To",
                        class: "has-text-danger is-tp-input-error",
                        "data-test": "error-message"
                      })
                    ])
                  ])
                ]),
                _hoisted_13
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["button is-primary pl-6", { 'is-loading': _ctx.loadingLogs }]),
                    type: "submit"
                  }, _hoisted_18, 2)
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"]),
          (_ctx.stats.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_TPChart, {
                    type: "donut",
                    title: "Stats",
                    series: _ctx.chartStats.series,
                    labels: _ctx.chartStats.labels,
                    colors: _ctx.chartStats.colors,
                    tooltips: _ctx.chartStats.tooltips
                  }, null, 8, ["series", "labels", "colors", "tooltips"])
                ]),
                (_ctx.topApps.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createVNode(_component_TPChart, {
                        type: "bar",
                        title: "Top Applications",
                        series: _ctx.chartApps.series,
                        labels: _ctx.chartApps.labels,
                        colors: _ctx.chartApps.colors
                      }, null, 8, ["series", "labels", "colors"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_22, " There are not records between the selected dates "))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
  ]))
}